"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScolapassPaymentsMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const _1 = require(".");
class ScolapassPaymentsMapper {
    toDomain(result) {
        const scolapassPaymentMapper = new _1.ScolapassPaymentMapper();
        const hasNextPage = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.payments.pageInfo.hasNextPage");
        const isLoading = lodash_1.default.get(result, "loading");
        const rawScolapassPayments = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.payments.edges");
        const scolapassPayments = rawScolapassPayments.map((_pay) => scolapassPaymentMapper.toDomain(_pay));
        return {
            isLoading,
            hasNextPage,
            scolapassPayments,
        };
    }
}
exports.ScolapassPaymentsMapper = ScolapassPaymentsMapper;
